import React, { useState } from 'react';
import '../css/MasterPage.css';
import LeafStorm from '../components/LeafStorm';
import Hamburger from '../components/Hamburger';
import Menu from '../components/Menu';
import { FaAnglesRight, FaChevronRight, FaMinus } from 'react-icons/fa6';

export default function WorkHistory({ setActivePage }) {
    const [open, setOpen] = useState(false);

    return (
        <div className='pageContainer'>
            <LeafStorm active={open} />
            <div className='navBar'>
                <a className='anchor'>🌸</a>
                <Hamburger open={open} setOpen={setOpen} />
                {open && <Menu isOpen={open} setActivePage={setActivePage} />}
            </div>
            <div className='phantomMenuContainer' />
            <div className='centeredContent'>
                <p className='subHeader'>Work History</p>
                <div className='workList'>
                    <div className='workItem'>
                        <p className='workTitle'><FaAnglesRight /> QA Engineer</p>
                        <p className='workEmployer'><FaChevronRight /> Davis County Government</p>
                        <p className='dutyItem'><FaMinus /> Test new web app changes</p>
                        <p className='dutyItem'><FaMinus /> Recommend and/or implement bug fixes</p>
                        <p className='dutyItem'><FaMinus /> Stress Apps to find deficiencies in product</p>
                    </div>

                    <div className='workItem'>
                        <p className='workTitle'><FaAnglesRight /> Tech Support Specialist II</p>
                        <p className='workEmployer'><FaChevronRight /> Davis County Government</p>
                        <p className='dutyItem'><FaMinus /> Triage and resolution of technology issues</p>
                        <p className='dutyItem'><FaMinus /> Install and maintain telecomunication infrastructure</p>
                        <p className='dutyItem'><FaMinus /> Termination of fiber and copper connections</p>
                        <p className='dutyItem'><FaMinus /> Train end users on computer and software processes</p>
                    </div>

                    <div className='workItem'>
                        <p className='workTitle'><FaAnglesRight /> Software Developer</p>
                        <p className='workEmployer'><FaChevronRight /> Fumbled Beans Game Studio</p>
                        <p className='dutyItem'><FaMinus /> Implement scenes and properties in Unity Projects</p>
                        <p className='dutyItem'><FaMinus /> Lead game development meetings on new implementations and fixes</p>
                        <p className='dutyItem'><FaMinus /> Implement all scripting for game logic</p>
                        <p className='dutyItem'><FaMinus /> Maintain version control system and review code pushes</p>
                    </div>
                </div>
                <p className='subHeader'>Education</p>
                <div className='workList'>
                    <div className='workItem'>
                        <p className='workTitle'><FaAnglesRight /> Davis Technical College</p>
                        <p className='workEmployer'><FaChevronRight /> Software Development Certificate</p>
                        <p className='dutyItem'><FaMinus /> Graduated January 2023</p>
                        <p className='dutyItem'><FaMinus /> Fullstack React development using MERN </p>
                        <p className='dutyItem'><FaMinus /> Fullstack React-Native development also using MERN</p>
                    </div>
                    <div className='workItem'>
                        <p className='workTitle'><FaAnglesRight /> Weber State University</p>
                        <p className='workEmployer'><FaChevronRight /> Working Towards Computer Science BS</p>
                        <p className='dutyItem'><FaMinus /> Expected Graduation Spring 2027</p>
                        <p className='dutyItem'><FaMinus /> Focus in web and user experience</p>
                        <p className='dutyItem'><FaMinus /> Heavy C# use for backend side of code</p>
                    </div>
                </div>
                <div className='bottomPadding'></div>
            </div>
        </div>
    )
}